import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { PREPROD_PREVIEW_ACTIONS } from "./types";
export var embedContextReducer = function(state, action) {
    switch(action.type){
        case PREPROD_PREVIEW_ACTIONS.SET_IS_IFRAME_VISIBLE:
            return _object_spread_props(_object_spread({}, state), {
                iframeState: _object_spread_props(_object_spread({}, state.iframeState), {
                    isIframeVisible: action.payload
                })
            });
        case PREPROD_PREVIEW_ACTIONS.SET_BOARD_STATUS:
            return _object_spread_props(_object_spread({}, state), {
                boardState: _object_spread_props(_object_spread({}, state.boardState), {
                    boardStatus: action.payload
                })
            });
        case PREPROD_PREVIEW_ACTIONS.SET_BOARD_CONTAINER_DISPLAY_MODE:
            return _object_spread_props(_object_spread({}, state), {
                boardContainerState: _object_spread_props(_object_spread({}, state.boardContainerState), {
                    boardContainerDisplayMode: action.payload
                })
            });
        case PREPROD_PREVIEW_ACTIONS.SET_IFRAME_CONFIG:
            return _object_spread_props(_object_spread({}, state), {
                iframeConfig: _object_spread({}, state.iframeConfig, action.payload)
            });
        case PREPROD_PREVIEW_ACTIONS.SET_IFRAME_REF:
            return _object_spread_props(_object_spread({}, state), {
                iframeState: _object_spread_props(_object_spread({}, state.iframeState), {
                    iframeRef: action.payload
                })
            });
        case PREPROD_PREVIEW_ACTIONS.SET_IFRAME_READY:
            return _object_spread_props(_object_spread({}, state), {
                iframeState: _object_spread_props(_object_spread({}, state.iframeState), {
                    isIframeReady: action.payload
                })
            });
        case PREPROD_PREVIEW_ACTIONS.TOGGLE_MODAL:
            return _object_spread_props(_object_spread({}, state), {
                boardContainerState: _object_spread_props(_object_spread({}, state.boardContainerState), {
                    boardContainerDisplayMode: !state.boardContainerState.boardContainerDisplayMode || state.boardContainerState.boardContainerDisplayMode === "inline" ? "modal" : "inline"
                })
            });
        case PREPROD_PREVIEW_ACTIONS.SET_EDITABLE_TEMPLATES_CONFIG:
            return _object_spread_props(_object_spread({}, state), {
                boardContainerState: _object_spread_props(_object_spread({}, state.boardContainerState), {
                    editableTemplates: _object_spread({}, state.boardContainerState.editableTemplates, action.payload)
                })
            });
        case PREPROD_PREVIEW_ACTIONS.SET_IS_BOARD_ACTIVE:
            return _object_spread_props(_object_spread({}, state), {
                boardContainerState: _object_spread_props(_object_spread({}, state.boardContainerState), {
                    editableTemplates: _object_spread_props(_object_spread({}, state.boardContainerState.editableTemplates), {
                        isEditableTemplateBoardActive: action.payload
                    })
                })
            });
        default:
            return state;
    }
};
